import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";
import { PaginationCustom } from "./ui/pagination-custom";
// interface PaginationState {
//   currentPage: number;
//   totalItems: number;
//   itemsPerPage: number;
// }
// export interface Column<T> {
//   key: string;
//   header: string;
//   render?: (row: T, index: number) => React.ReactNode;
//   headerClassName?: string; // 👈 style only header
//   cellClassName?: string;   // 👈 style only cell
// }


// interface DataTableProps<T> {
//   data: T[];
//   columns: Column<T>[];
//   pagination: PaginationState;
// //   onPageChange: (page: number) => void;
// }

// export function DataTable<T>({
//   data,
//   columns,
//   pagination,
// //   onPageChange,
// }: DataTableProps<T>) {
//   const { currentPage, totalItems, itemsPerPage } = pagination;
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const totalPages = Math.ceil(totalItems / itemsPerPage);

//   return (
//     <div className="bg-white rounded-lg border border-gray-200">
//       {/* Table */}
//       <Table>
//   <TableHeader>
//     <TableRow>
//       {columns.map((col) => (
//         <TableHead key={col.key} className={col.headerClassName}>
//           {col.header}
//         </TableHead>
//       ))}
//     </TableRow>
//   </TableHeader>

//   <TableBody>
//     {data.map((row, rowIndex) => (
//       <TableRow key={rowIndex}>
//         {columns.map((col) => (
//           <TableCell key={col.key} className={col.cellClassName}>
//             {col.render
//               ? col.render(row, startIndex + rowIndex)
//               : (row as any)[col.key]}
//           </TableCell>
//         ))}
//       </TableRow>
//     ))}
//   </TableBody>
// </Table>

     
//       {totalPages > 1 && (
//         <div className="flex justify-between items-center p-4 border-t">
//           <button
//             disabled={currentPage === 1}
//             onClick={() => onPageChange(currentPage - 1)}
//             className="px-3 py-1 border rounded disabled:opacity-50"
//           >
//             Previous
//           </button>
//           <span>
//             Page {currentPage} of {totalPages}
//           </span>
//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => onPageChange(currentPage + 1)}
//             className="px-3 py-1 border rounded disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }
// import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";

export interface Column<T> {
  key: string;
  header: string;
  render?: (row: T, index: number) => React.ReactNode;
  headerClassName?: string;
  cellClassName?: string;
}

interface DataTableProps<T> {
  data: T[];
  columns: Column<T>[];
  onRowClick?:(row: T, index: number)=>void
}

export function DataTable<T>({ data, columns,onRowClick }: DataTableProps<T>) {
  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-50 hover:bg-gray-50">
            {columns.map((col) => (
              <TableHead key={col.key} className={col.headerClassName}>
                {col.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody>
          
          {/* {data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {columns.map((col) => (
                <TableCell key={col.key} className={col.cellClassName}>
                  {col.render ? col.render(row, rowIndex) : (row as any)[col.key]}
                </TableCell>
              ))}
            </TableRow>
          ))} */}
           {data.length > 0 ? (
            data.map((row, rowIndex) => (
              <TableRow key={rowIndex}  onClick={onRowClick ? () => onRowClick(row, rowIndex) : undefined}
  className={onRowClick ? "cursor-pointer hover:bg-gray-50" : ""}>
                {columns.map((col) => (
                  <TableCell key={col.key} className={col.cellClassName}>
                    {col.render ? col.render(row, rowIndex) : (row as any)[col.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={columns.length} // span all columns
                className="text-center text-gray-500 py-4"
              >
                No data found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
